import {
  Product,
  ProductSpecification,
  Manufacturer,
  BundleAndSave,
  VariantSelectionOptions,
  AddToCartOption,
  CalculatorWidget,
  UpgradedProduct,
  FeatureIcon,
  ProductDetailsPrices,
} from '@/types/productPage';
import { Breadcrumb } from '@/types/breadcrumbs';
import { Rebate } from '@/types/Rebate';
import { Ratings } from '@/types/Ratings';
import { Review } from '@/types/Review';
import { LoyaltyPoints } from '@/types/LoyaltyPoints';
import { ContactDetails } from '@/types/ContactDetails';
import { Schematics } from '@/types/Schematics';
import { ShippingRateResponses } from '@/types/ShippingRateResponses';
import { ImageProps } from '@/types/Image';
import { AutoClipCoupon } from '@/types/Coupons';
import { ItemSet } from '@/types/itemSets';

export type ProductDetails = {
  addToCartOption: AddToCartOption | null;
  loyaltyPoints: LoyaltyPoints | null;
  inventoryMessage: string | null;
  returnDays: ReturnDays;
  showAmmoBanner: boolean;
  discontinued: boolean;
  productSku: string;
  subProductSku: string;
  breadcrumbs: Array<Breadcrumb>;
  itemCode: string | null;
  publishDate: string | null;
  adminEditUrl: string | null;
  shortName: string;
  name: string;
  rating: number | null;
  numReviews: number | null;
  prices: ProductDetailsPrices;
  mainImages: Array<ImageProps>;
  videos: Array<string>;
  showAffirm: boolean;
  new: boolean;
  isDeliverable: boolean;
  sellerName: string | null;
  warranty: string | null;
  couponAllowed: boolean;
  ratings: Array<Ratings>;
  descriptions: Array<string> | null;
  schematics: Array<Schematics> | null;
  extraDescription: string | null;
  manufacturer: Manufacturer | null;
  specifications: Array<ProductSpecification> | null;
  bundleAndSave: BundleAndSave | null;
  purchaseLimit: number | null;
  shippingEstimation: string | null;
  variantSelection: VariantSelectionOptions;
  rebate: Rebate | null;
  itemCondition: ItemCondition | null;
  reviews: Array<Review> | null;
  salesVelocity30D: string | null;
  contactDetails: ContactDetails | null;
  itemSet: ItemSet | null;
  calculatorWidget: CalculatorWidget | null;
  keyProductFeatures: Array<string>;
  defaultSubProduct: boolean;
  upgradedProduct: UpgradedProduct;
  manualUrl: string | null;
  addedToWishList: boolean;
  modelSchematicUrl: string | null;
  addToWishListUrl: string;
  featureIcons: Array<FeatureIcon> | null;
  includedInPackage: string | null;
  displayManufacturers: Array<Array<Breadcrumb>> | null;
  upsellingBanners: Array<string> | null;
  numAnsweredQuestions: number | null;
  numQuestions: number | null;
  schemaAttributes: SchemaAttributes | null;
  showNotifyMe: boolean;
  showLiveChat: boolean;
  shippingRateResponses: ShippingRateResponses;
  showPcp: boolean;
  expectedInStockMessage: string | null;
  subProductIds: Array<number> | null;
  displayCategoryId: number | null;
  specialIconUrl: string | null;
  reviewsDisplayThreshold: number;
  showSezzle: boolean;
  autoClipCoupon: AutoClipCoupon | null;
};

type SchemaAttributes = {
  productName: string | null;
  productDescription: string | null;
  manufacturerName: string | null;
  availability: string | null;
  skillGroup: string | null;
  prices: ProductDetailsPrices | null;
};

export type ItemCondition = {
  label: string | null;
  shortDescription: string | null;
  longDescription: string | null;
};

export type DeleteProductRequest = {
  productItemId: number;
  orderId: number;
  product: Product;
};

export type ReturnDaysData = {
  description: string | null;
  label: string;
};

export type ReturnDays = ReturnDaysData | null;

export type ProductPageViewRequest = {
  sku: string;
  itemCode: string;
  brandCode: number;
};

export const ALGONOMY_PLACEMENTS = 'item_page.rr1|item_page.rr2|item_page.rr3|item_page.rr4|item_page.rr5';
export const ALGONOMY_MOBILE_PLACEMENTS = 'item_page.mrr1|item_page.mrr2|item_page.mrr3|item_page.mrr4|item_page.mrr5';
export const DISCONTINUED_ALGONOMY_PLACEMENTS = 'item_page.rroos|item_page.rr4|item_page.rr5';
export const DISCONTINUED_ALGONOMY_PLACEMENTS_MOBILE = 'item_page.mrroos|item_page.mrr4|item_page.mrr5';
